module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('transition', {
    attrs: {
      "name": "el-zoom-in-top"
    }
  }, [_c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content"
  }, [_c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', [_vm._v("Stay Tuned!")]), _vm._v(" "), _c('h2', [_vm._v("We will be filling this up with content in the future!")])])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2441a9c2!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/UpdatePlaceholderPage.vue
// module id = 1275
// module chunks = 2